import styled from '@emotion/styled'

import { INVOICE_LOGO_WRAPPER_HEIGHT } from '../../constants/invoiceLogoWrapperHeight'

export const InvoiceLogoWrapper = styled.div`
  height: ${INVOICE_LOGO_WRAPPER_HEIGHT}px;
`
